import { Stack, styled } from "@mui/material";
import { Img, LgTextSemiBold, OpenTabLink, SmTextMd } from "Components";
import CategorySkeleton from "Components/skeleton/CategorySkeleton";
import { COLORS } from "constants/layout";
import { DIRECT_PATHS } from "constants/routes";
import { formatImg } from "helpers/format";
import { useCommonData } from "providers/common-data";
import { memo } from "react";
import { useIntl } from "react-intl";

export const TrendingCategories = memo(() => {
  const t = useIntl();
  const { appConfigs, appConfigLoading } = useCommonData();

  return (
    <StyledTrendingCategories spacing={1}>
      <LgTextSemiBold className="title" color={COLORS.gray[800]}>
        {t.formatMessage({ id: "top_buying_lead_cate_of_month" })}
      </LgTextSemiBold>

      <Stack direction="row" spacing={1} className="scroll-box purple-scroll">
        {appConfigLoading &&
          Array.from(new Array(8)).map((_, index) => (
            <CategorySkeleton key={index} style={{ flex: 1 }} />
          ))}
        {appConfigs?.monthlyCates?.map((category) => (
          <OpenTabLink
            href={DIRECT_PATHS.categoryBuyer(category.value)}
            key={category.value}
            style={{ flex: 1 }}
          >
            <Stack className="category-box">
              {category.image && (
                <Img
                  height={100}
                  width={100}
                  src={formatImg(category.image, 2)}
                />
              )}
              <SmTextMd
                className="cutoff-text twoline"
                textAlign="center"
                maxWidth={145}
                mt={1}
                mb={0.5}
              >
                {category.label}
              </SmTextMd>
            </Stack>
          </OpenTabLink>
        ))}
      </Stack>
    </StyledTrendingCategories>
  );
});

export const TrendingFeaturedCategories = () => {
  const t = useIntl();
  const categories = [
    { value: "Spices", label: "Spices", image: "/files/Spice.jpg" },
    { value: "Rice", label: "Rice", image: "/files/Rice (2).jpg" },
    { value: "Coffee", label: "Coffee", image: "/files/Coffee (2).jpg" },
    { value: "Soybean", label: "Soybean", image: "/files/Soybean.jpg" },
    {
      value: "Fresh-Vegetables",
      label: "Fresh vegetables",
      image: "/files/Fresh Vegetables.jpg",
    },
    {
      value: "Frozen-Chicken",
      label: "Frozen chicken",
      image: "/files/Frozen chicken.jpg",
    },
    {
      value: "Cashew-Nuts",
      label: "Cashew Nuts",
      image: "/files/Cashew Nuts.jpg",
    },
    {
      value: "Fresh-Durian",
      label: "Fresh Durian",
      image: "/files/Fresh Durian.jpg",
    },
  ];
  return (
    <StyledTrendingCategories>
      <LgTextSemiBold className="title">
        {t.formatMessage({ id: "top_categories_of_month" })}
      </LgTextSemiBold>

      <Stack direction="row" spacing={1} className="scroll-box white-scroll">
        {categories.map((category) => (
          <OpenTabLink
            href={DIRECT_PATHS.categorySupplier(category.value)}
            key={category.value}
            style={{ flex: 1 }}
          >
            <Stack flex={1} className="category-box" spacing={1}>
              <Img height={100} width={100} src={formatImg(category.image)} />
              <SmTextMd className="cutoff-text twoline" textAlign="center">
                {category.label}
              </SmTextMd>
            </Stack>
          </OpenTabLink>
        ))}
      </Stack>
    </StyledTrendingCategories>
  );
};

const StyledTrendingCategories = styled(Stack)(({ theme }) => ({
  borderRadius: 8,
  padding: 12,
  backgroundColor: "#fff",
  ".category-box": {
    borderRadius: 8,
    alignItems: "center",
    backgroundColor: "#fff",
    minWidth: 167,
    padding: "0 8px",
    img: {
      objectFit: "cover",
      borderRadius: "50%",
    },
  },
  [theme.breakpoints.down("md")]: {
    padding: 8,
    ".title": {
      fontSize: 16,
    },
  },
}));
